import React from 'react';
class MathQuilElement extends React.Component {

    componentDidMount = () => {
        var MQ = window.MathQuill.getInterface(2);
        MQ.StaticMath(this.refs.latexEle).latex(this.props.value);
    }

    render = () => {
        return (
            <span ref="latexEle"></span>
        )
    }
}

export default MathQuilElement;
